import {
  alpha,
  darken,
  getContrastRatio,
  lighten,
  PaletteColor,
} from '@mui/material/styles';

const withAlphas = (color: PaletteColor): PaletteColor => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5),
  };
};

export const neutral = {
  50: '#F8F9FA',
  100: '#F3F4F6',
  200: '#DBDFE5',
  300: '#D2D6DB',
  400: '#9DA4AE',
  500: '#6C737F',
  600: '#4D5761',
  700: '#2F3746',
  800: '#1C2536',
  900: '#111927',
};

export const indigo = withAlphas({
  lightest: '#F5F7FF',
  light: '#EBEEFE',
  main: '#009EFA',
  dark: '#4338CA',
  darkest: '#312E81',
  contrastText: '#FFFFFF',
});

export const brand = withAlphas({
  lightest: '#ECF8FF',
  light: '#47D6FA',
  main: '#009EFA',
  dark: '#008FE1',
  darkest: '#0067B1',
  contrastText: '#FFFFFF',
});

export const createBrandScale = (main: string): PaletteColor =>
  withAlphas({
    lightest: lighten(main, 0.92),
    light: lighten(main, 0.3),
    main,
    dark: darken(main, 0.1),
    darkest: darken(main, 0.35),
    contrastText:
      getContrastRatio(main, '#FFFFFF') >= 3 ? '#FFFFFF' : neutral[900],
  });

export const success = withAlphas({
  lightest: '#F0FDF9',
  light: '#3FC79A',
  main: '#4CA960',
  dark: '#0B815A',
  darkest: '#134E48',
  contrastText: '#FFFFFF',
});

export const info = withAlphas({
  lightest: '#ECFDFF',
  light: '#CFF9FE',
  main: '#06AED4',
  dark: '#0E7090',
  darkest: '#164C63',
  contrastText: '#FFFFFF',
});

export const warning = withAlphas({
  lightest: '#FFFAEB',
  light: '#FEF0C7',
  main: '#F79009',
  dark: '#B54708',
  darkest: '#7A2E0E',
  contrastText: '#FFFFFF',
});

export const error = withAlphas({
  lightest: '#FEF3F2',
  light: '#FEE4E2',
  main: '#DA1E28',
  dark: '#B42318',
  darkest: '#7A271A',
  contrastText: '#FFFFFF',
});
